function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n        .st0{fill:#B0B9BD;}\n    ");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-38.000000, -13.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(38.000000, 13.000000)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5.5,18.7c-3.6-3.6-3.6-9.6,0-13.2s9.6-3.6,13.2,0s3.6,9.6,0,13.2S9.1,22.3,5.5,18.7 M20.5,3.5 c-4.7-4.7-12.3-4.7-17,0s-4.7,12.3,0,17s12.3,4.7,17,0S25.2,8.2,20.5,3.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M15.2,16.6c-0.3,0-0.5-0.2-0.6-0.2l-2.7-2.7l-2.6,2.6c-0.2,0.2-0.3,0.2-0.6,0.2s-0.6,0-0.9-0.5 c-0.3-0.3-0.5-0.6-0.5-0.9c0-0.3,0.2-0.5,0.2-0.6l2.6-2.6L7.6,9.4C7.3,9.1,7.1,8.5,7.7,7.9C8,7.6,8.3,7.4,8.6,7.4 s0.5,0.2,0.6,0.2l2.6,2.6l2.6-2.6c0.2-0.2,0.3-0.2,0.6-0.2c0.3,0,0.6,0,0.9,0.5c0.6,0.6,0.5,1.2,0.2,1.5l-2.6,2.6l2.6,2.6 c0.2,0.2,0.2,0.3,0.2,0.6c0,0.3,0,0.6-0.5,0.9C15.8,16.4,15.5,16.6,15.2,16.6"
})));

var SvgDeleteCross = function SvgDeleteCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete_cross.b775d35a.svg";
export { ForwardRef as ReactComponent };